import React, { useState, useMemo, useEffect } from "react";
import { Col, NavItem, NavLink, Nav } from "reactstrap";
import styled from "styled-components";
import useAuth from "hooks/useAuth";
import LoadingScreen from "components/customs/loading-screen";
import { ACCOUNT_SUPER_ADMIN } from "utility/constants";
import { hasPermission } from "utility/helpers";
import DailyReportTab from "./DailyReportTab";
import SummaryReportTab from "./SummaryReportTab";

const StyleTabs = styled(Nav)`
  justify-content: space-between;
  margin-top: 50px;

  li {
    margin-bottom: 0;
    margin-top: 6px;
    margin-left: 0;
    margin-right: 0;
    cursor: pointer;

    a {
      color: black;
      font-weight: 500;

      &.active {
        font-weight: 600;
        color: #00316d !important;
        border: none !important;
        border-bottom: 2px solid #00316d !important;
        background: transparent !important;
      }

      :hover {
        border-color: transparent !important;
      }
    }
  }
`;

const Wrapper = styled.div``;

const TabsContainer = styled.div`
  display: flex;
`;

const SummaryExport = () => {
  const { user } = useAuth();

  const hasSummaryPermission =
    user?.type === ACCOUNT_SUPER_ADMIN && hasPermission("summary-view");

  const tabs = useMemo(
    () => [
      {
        id: "1",
        key: "summary",
        label: "Summary Report",
        isShown: hasSummaryPermission,
        content: <SummaryReportTab />,
      },
      {
        id: "2",
        key: "daily",
        label: "Daily Report",
        isShown: true,
        content: <DailyReportTab />,
      },
    ],
    [hasSummaryPermission]
  );

  const visibleTabs = useMemo(() => tabs.filter((tab) => tab.isShown), [tabs]);

  const initialActiveTab = useMemo(
    () => visibleTabs[0]?.id || "2",
    [visibleTabs]
  );

  const [activeTab, setActiveTab] = useState(initialActiveTab);

  useEffect(() => {
    // Ensure activeTab is always a visible tab
    if (!visibleTabs.find((tab) => tab.id === activeTab)) {
      setActiveTab(initialActiveTab);
    }
  }, [activeTab, visibleTabs, initialActiveTab]);

  if (!user) {
    return <LoadingScreen />;
  }

  return (
    <Wrapper>
      <Col className="container">
        <StyleTabs tabs>
          <TabsContainer>
            {visibleTabs.map((tab) => (
              <NavItem key={tab.id}>
                <NavLink
                  className={activeTab === tab.id ? "active" : ""}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label}
                </NavLink>
              </NavItem>
            ))}
          </TabsContainer>
        </StyleTabs>

        {visibleTabs.find((tab) => tab.id === activeTab)?.content}
      </Col>
    </Wrapper>
  );
};

export default SummaryExport;
